import '@/styles/globals.css';
import '../../node_modules/@rimactechnology/rimac-ui-lib/dist/style.css';

import { ApolloProvider } from '@apollo/client';
import type { AppProps } from 'next/app';
import Head from 'next/head';

import { useApollo } from '@/api/apolloClient';
import { GoogleAnalytics } from '@/components/google/GoogleAnalytics';
import { Impressum } from '@/components/impressum/Impressum';

const App = ({ Component, pageProps }: AppProps) => {
  const client = useApollo(pageProps);

  return (
    <ApolloProvider client={client}>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Rimac Energy</title>
      </Head>
      <Component {...pageProps} />
      <Impressum key="impressum" />
      <GoogleAnalytics />
    </ApolloProvider>
  );
};

export default App;
